(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const searchWrappers = document.querySelectorAll('[data-predictive-search]');

  if (!searchWrappers.length) return;

  const mobileBreakpoint = window.matchMedia('(max-width: 749px)');
  const urlParams = new URLSearchParams(window.location.search);
  const isSearchPage = /\/search\/?$/.test(window.location.pathname);
  const searchPageTerm = isSearchPage ? (urlParams.get('q') || '').trim() : '';

  function debounce(fn, wait = 250) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = window.setTimeout(() => fn(...args), wait);
    };
  }

  searchWrappers.forEach((wrapper) => {
    const toggle = wrapper.querySelector('[data-search-toggle]');
    const input = wrapper.querySelector('[data-search-input]');
    const results = wrapper.querySelector('[data-search-results]');
    const form = wrapper.querySelector('form');

    if (!toggle || !input || !results || !form) return;

    const close = () => {
      wrapper.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      input.setAttribute('aria-expanded', 'false');
      results.hidden = true;
      results.innerHTML = '';
    };

    const open = () => {
      wrapper.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      input.setAttribute('aria-expanded', 'true');
    };

    const applySearchPageState = () => {
      if (!searchPageTerm) return;

      input.value = searchPageTerm;

      if (mobileBreakpoint.matches) {
        close();
        return;
      }

      wrapper.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      input.setAttribute('aria-expanded', 'false');
      results.hidden = true;
      results.innerHTML = '';
    };

    const fetchResults = debounce(async (term) => {
      if (!term.length) {
        close();
        return;
      }

      try {
        const params = new URLSearchParams({
          q: term,
          'resources[type]': 'product',
          'resources[limit]': '6',
          'resources[limit_scope]': 'all',
          'resources[options][unavailable_products]': 'last',
          'resources[options][fields]': 'title,product_type,variants.title,vendor,tag',
          section_id: 'predictive-search'
        });

        const response = await fetch(`${root}search/suggest?${params.toString()}`, {
          headers: { Accept: 'text/html' }
        });

        if (!response.ok) {
          throw new Error('Predictive search failed');
        }

        const text = await response.text();
        const html = new DOMParser().parseFromString(text, 'text/html');
        const section = html.querySelector('#shopify-section-predictive-search');

        if (!section || !section.innerHTML.trim()) {
          results.hidden = true;
          results.innerHTML = '';
          return;
        }

        results.innerHTML = section.innerHTML;
        results.hidden = false;
        open();
      } catch (error) {
        console.error(error);
      }
    }, 250);

    toggle.addEventListener('click', () => {
      const isOpen = wrapper.classList.contains('is-open');

      if (isOpen && !input.value.trim()) {
        close();
      } else {
        open();
        input.focus();
      }
    });

    input.addEventListener('input', (event) => {
      const term = event.target.value.trim();
      fetchResults(term);
    });

    input.addEventListener('focus', () => {
      open();

      if (input.value.trim()) {
        fetchResults(input.value.trim());
      }
    });

    document.addEventListener('click', (event) => {
      if (!wrapper.contains(event.target)) {
        if (searchPageTerm) {
          applySearchPageState();
        } else {
          close();
        }
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        if (searchPageTerm) {
          applySearchPageState();
        } else {
          close();
        }

        window.HohoCart?.closeDrawer?.();
      }
    });

    form.addEventListener('submit', (event) => {
      const term = input.value.trim();

      if (!term) {
        event.preventDefault();
        open();
        input.focus();
        return;
      }

      event.preventDefault();
      window.location.assign(`${root}search?q=${encodeURIComponent(term)}&type=product`);
    });

    if (searchPageTerm) {
      applySearchPageState();

      if (typeof mobileBreakpoint.addEventListener === 'function') {
        mobileBreakpoint.addEventListener('change', applySearchPageState);
      } else if (typeof mobileBreakpoint.addListener === 'function') {
        mobileBreakpoint.addListener(applySearchPageState);
      }
    }
  });
})();